import  axiosI  from '../Service/service';
import {
    GET_PARTICIPANTS,
    GET_HERE_NOW,
    HIDE_LIVE_CHAT_POP_UP,
    SCROLL_LIVE_CHAT,
    INCREASE_LIVE_CHAT_INDEX
} from './actionTypes';
import * as constants from '../Constants';

export const getParticipants = (data) => {
    return dispatch =>
        axiosI.get(`${constants.API.getParticipantUserListApi}/${data.userId}/${data.GooglePlaceId}/${data.PageNumber}/${data.PageSize}`).then((response) => {
            dispatch({
                type: GET_PARTICIPANTS,
                payload: response.data
            });
        }).catch(() => {
            // console.log('Error occurred with fetching getParticipants API. ', err);
        });
};
export const getHereNow = (data) => {
    return dispatch =>
        axiosI.post(constants.API.getAvailableUsersApi,data).then((response) => {
            dispatch({
                type: GET_HERE_NOW,
                payload: response.data
            });
        }).catch(() => {
            // console.log('Error occurred with fetching getHereNow API. ', err);
        });
};

export const hideLiveChatPopUp = () => {
    return dispatch =>
        dispatch({
            type:HIDE_LIVE_CHAT_POP_UP,
            payload:false
        });
};

export const disableScroll = () => {
    return dispatch =>
        dispatch({
            type:SCROLL_LIVE_CHAT,
            payload:false
        });
};

export const increaseIndex = () => {
    return dispatch =>
        dispatch({
            type:INCREASE_LIVE_CHAT_INDEX,
            payload:true
        });
};